import { useTranslation } from 'react-i18next';
import { usePriceGroup } from 'core/contexts/priceGroup';
import { Form } from 'react-final-form';
import { Box, FormHelperText } from '@mui/material';
import Title from 'modules/Pricing/components/Title';
import ActionButtons from '../ActionButtons';

const DeleteRange = ({ priceGroupId, handleClose, rangeToDelete }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`price_group_id.delete_range.${key}`);
    const { submittingPriceGroup, deleteRange } = usePriceGroup();

    const handleSubmit = async (values) => {
        await deleteRange(priceGroupId, values.quantityFrom, values.quantityTo);
        handleClose();
    };

    const validateForm = (values) => {
        const errors = {};

        if (!values.rowId) errors.delete = translate('validate_form.row_id');

        return errors;
    };

    if (!rangeToDelete?.rowId) {
        handleClose();
        return;
    }

    return (
        <Form
            key={`delete-price-group-range-${priceGroupId}`}
            onSubmit={handleSubmit}
            validate={validateForm}
            initialValues={{ ...rangeToDelete }}
            render={({ errors, handleSubmit, form }) => (
                <form key={`delete-price-group-range-${priceGroupId}`} onSubmit={handleSubmit} noValidate>
                    <Box component="section" py={2}>
                        <Title title={`${translate('title')} ${rangeToDelete?.quantityFrom} ${translate('to')} ${rangeToDelete?.quantityTo}`} description={`${translate('description')} ${rangeToDelete?.quantityFrom} ${translate('to')} ${rangeToDelete?.quantityTo}?`} />

                        {errors.delete && (
                            <FormHelperText error={errors.delete} sx={{ my: 1 }}>
                                {errors.delete}
                            </FormHelperText>
                        )}

                        <ActionButtons
                            handleSubmit={(e) => {
                                return handleSubmit(e);
                            }}
                            handleClose={(e) => {
                                handleClose();
                                return form.reset(e);
                            }}
                            submitting={submittingPriceGroup}
                            labelNext={translate('delete')}
                        />
                    </Box>
                </form>
            )}
        />
    );
};

export default DeleteRange;
